import script from "./CardsCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardsCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./CardsCarousel.vue?vue&type=style&index=0&id=0316819c&lang=css"

const __exports__ = script;

export default __exports__